import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Dispositif } from '@features/referentiel/models/dispositif';

export const SelectionDispositifActions = createActionGroup({
  source: 'Selection Dispositif',
  events: {
    'Create Dispositif Remboursement': props<{ dispositif: Dispositif }>(),
    'Create Dossier Success': props<{ dispositif: Dispositif; dossier: any }>(),
    'Create Dossier Error': props<{ error: any }>(),
    'No Action': emptyProps(),
  },
});
